var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "39",
        height: "39",
        viewBox: "0 0 39 39",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("circle", {
        attrs: {
          cx: "19.5",
          cy: "19.5",
          r: "19",
          fill: "white",
          "fill-opacity": "0.2",
          stroke: "url(#paint0_linear)",
        },
      }),
      _c("path", {
        attrs: {
          d: "M11.5 28H27.5V16.5H28.5V14.5L19.5 9L10.5 14.5V16.5H11.5V28Z",
          stroke: "white",
        },
      }),
      _c("circle", {
        attrs: { cx: "17", cy: "17.5", r: "1", stroke: "white" },
      }),
      _c("circle", {
        attrs: { cx: "22", cy: "22.5", r: "1", stroke: "white" },
      }),
      _c("path", {
        attrs: {
          d: "M22.5 16.5L16.5 23.5",
          stroke: "white",
          "stroke-linejoin": "round",
        },
      }),
      _c(
        "defs",
        [
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint0_linear",
                x1: "19.5",
                y1: "0",
                x2: "19.5",
                y2: "39",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", {
                attrs: { "stop-color": "white", "stop-opacity": "0" },
              }),
              _c("stop", { attrs: { offset: "1", "stop-color": "white" } }),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }